import React from "react";
export default function ProgressBarTop(props) {
  const visibility = props.bg;
  if (typeof window !== "undefined") {
    window.onscroll = function () {
      scroll();
    };

    function scroll() {
      if (typeof window !== "undefined") {
        let winScroll =
          document.body.scrollTop || document.documentElement.scrollTop;
        let height =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 105;
        document.getElementById("myBar").style.width = scrolled + "%";
      }
    }
  }
  return (
    <div class="progress-container">
      <div
        class="progress-bar"
        id="myBar"
        style={{ visibility: visibility }}
      ></div>
    </div>
  );
}
